import { Address } from '../../Address/Address';
import { CustomerPerson } from '../../Person/Person';

export const checkoutDetailsTabKey = 'checkout-details-tab';

export enum CheckoutDetailsFormAttribute {
    firstName = 'checkout-first-name',
    lastName = 'checkout-last-name',
    email = 'checkout-email',
    phoneNumber = 'checkout-phone-number',
    subscribeToNewsletter = 'checkout-subscribe-to-newsletter',
    shippingStreet = 'checkout-shipping-street',
    shippingHouseNumber = 'checkout-shipping-house-number',
    shippingAddition = 'checkout-shipping-addition',
    shippingPostalCode = 'checkout-shipping-postal-code',
    shippingCity = 'checkout-shipping-city',
    hasBillingAddress = 'checkout-has-billing-address',
    billingStreet = 'checkout-billing-street',
    billingHouseNumber = 'checkout-billing-house-number',
    billingAddition = 'checkout-billing-addition',
    billingPostalCode = 'checkout-billing-postal-code',
    billingCity = 'checkout-billing-city',
    createAccount = 'checkout-create-account',
}

export type CheckoutAddress = Omit<Address, 'id'>;

export interface CheckoutDetailsFormData extends CustomerPerson {
    subscribeToNewsletter: boolean;
    shippingStreet: string;
    shippingHouseNumber: string;
    shippingAddition: string;
    shippingPostalCode: string;
    shippingCity: string;
    hasBillingAddress: boolean;
    billingStreet: string;
    billingHouseNumber: string;
    billingAddition: string;
    billingPostalCode: string;
    billingCity: string;
    createAccount: boolean;
    password?: string;
}

export interface CheckoutCreateAccountFormData extends CheckoutDetailsFormData {
    password: string;
}

export interface CheckoutAddresses {
    shippingAddress: CheckoutAddress;
    billingAddress: CheckoutAddress;
}

export type CheckoutFormData = CustomerPerson & CheckoutAddresses;
